import { Button, Paper } from '@mui/material'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import CustomBarcodeScanner from 'common/components/CustomBarcodeScanner'
import Icon from 'icons/Icons'
import i18n from 'lang/idiomas'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'

const PanelNumerico = ({
  fontSize = 'xxx-large',
  readings,
  onClick = () => {},
  onDelete = () => {},
  onCheck = () => {},
  disableButtons = false,
}) => {
  const [showReader, setShowReader] = useState(false)
  const normalizedReadings = readings?.toLowerCase() || 'off'

  const handleClick = (btn) => {
    if (btn.currentTarget.dataset.type === 'number') {
      onClick(btn.currentTarget.dataset.value)
    }
  }
  const handleDelete = () => {
    onDelete()
  }
  const handleCheck = () => {
    onCheck()
  }
  const handleQR = () => {
    setShowReader(true)
  }
  const closeReader = () => {
    setShowReader(false)
  }

  const onQRRead = (result) => {
    if (disableButtons) return
    onClick(result)
    onCheck(result)
    if (normalizedReadings === 'demanda') closeReader()
  }

  const onQRError = (err) => {
    enqueueSnackbar('Se ha producido un error al leer el código QR', { variant: 'error' })
    setShowReader(false)
  }

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        p: 2,
        backgroundColor: 'background.paper',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          backgroundColor: 'background.paper',
        }}
      >
        <Box sx={{ flexGrow: 1, mb: 2, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="1"
            disabled={disableButtons}
            onClick={handleClick}
          >
            1
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ mx: 2, flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="2"
            disabled={disableButtons}
            onClick={handleClick}
          >
            2
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="3"
            disabled={disableButtons}
            onClick={handleClick}
          >
            3
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1, mb: 2, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="4"
            disabled={disableButtons}
            onClick={handleClick}
          >
            4
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ mx: 2, flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="5"
            disabled={disableButtons}
            onClick={handleClick}
          >
            5
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="6"
            disabled={disableButtons}
            onClick={handleClick}
          >
            6
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1, mb: 2, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="7"
            disabled={disableButtons}
            onClick={handleClick}
          >
            7
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ mx: 2, flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="8"
            disabled={disableButtons}
            onClick={handleClick}
          >
            8
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="9"
            disabled={disableButtons}
            onClick={handleClick}
          >
            9
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            data-type="number"
            data-value="0"
            disabled={disableButtons}
            onClick={handleClick}
          >
            0
          </Button>
          <Button
            variant="contained"
            color="error"
            size="large"
            sx={{ mx: 2, flexGrow: 1, fontSize: fontSize }}
            disabled={disableButtons}
            onClick={handleDelete}
          >
            <Icon icon="fi-rr-delete" size={fontSize} />
          </Button>
          <Button
            variant="contained"
            color="success"
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            disabled={disableButtons}
            onClick={handleCheck}
          >
            <Icon icon="fi-rr-check" size={fontSize} />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flexGrow: 0,
          gap: 2,
          ml: 4,
          backgroundColor: 'background.paper',
        }}
      >
        {normalizedReadings === 'off' ? (
          <></>
        ) : normalizedReadings === 'demanda' ? (
          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{ flexGrow: 1, fontSize: fontSize }}
            onClick={handleQR}
          >
            <Icon icon="fi-rr-qrcode" size="xxx-large" />
          </Button>
        ) : (
          <CustomBarcodeScanner
            headerText={i18n.t('qrscan', { defaultValue: 'Escanea el código QR' })}
            width="350px"
            height="auto"
            stop={!showReader}
            onRead={onQRRead}
            onError={onQRError}
          />
        )}
      </Box>
      {normalizedReadings === 'off' ? (
        <></>
      ) : (
        <Modal open={showReader} onClose={closeReader}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '100%', md: '50%' },
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
            }}
          >
            <CustomBarcodeScanner
              headerText={i18n.t('qrscan', { defaultValue: 'Escanea el código QR' })}
              stop={!showReader}
              onRead={onQRRead}
              onError={onQRError}
            />
            <Button
              variant="contained"
              color="error"
              size="large"
              sx={{ mt: 2 }}
              onClick={closeReader}
              fullWidth
            >
              {i18n.t('general.cerrar', { defaultValue: 'Cerrar' })}
            </Button>
          </Box>
        </Modal>
      )}
    </Paper>
  )
}

export default PanelNumerico
